const HTML_ESCAPES: Record<string, string> = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
}

/**
 * Escape a value for safe interpolation into an HTML template that gets assigned to innerHTML
 * (e.g. Google Maps `InfoWindow.setContent`). External API data — toll plaza names, fuel-station
 * names, payment methods — must never be injected verbatim, or a malicious string could run
 * `<script>`/event-handler XSS in the dispatcher's browser.
 */
export const escapeHtml = (value: unknown): string => String(value ?? '').replace(/[&<>"']/g, (c) => HTML_ESCAPES[c])
